import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-flexbox-grid";
import { Container } from "../../atoms/Container";
import {
  GuidesHeaderTitle,
  GuidesSubHeader,
  GuidesTitleContainer,
  HeaderImage,
  HeaderImageContainer,
  HeaderImageInnerContainer,
  GuidesHeaderDescription,
} from "./style";

class GuidesHeader extends PureComponent {
  render() {
    const { headerColor, headerIcon, headerTitle, headerDescription } = this.props;

    return (
      <GuidesSubHeader backgroundColor={headerColor}>
        <Container>
          <Row>
            <Col md={8} lg={9}>
              <GuidesTitleContainer>
                <GuidesHeaderTitle>{headerTitle}</GuidesHeaderTitle>
                {headerDescription && <GuidesHeaderDescription>{headerDescription}</GuidesHeaderDescription>}
              </GuidesTitleContainer>
            </Col>
            <Col md={4} lg={3}>
              <HeaderImageContainer>
                <HeaderImageInnerContainer>
                  <HeaderImage src={headerIcon} alt={headerTitle || "Wine Guides"} />
                </HeaderImageInnerContainer>
              </HeaderImageContainer>
            </Col>
          </Row>
        </Container>
      </GuidesSubHeader>
    );
  }
}

GuidesHeader.propTypes = {
  headerColor: PropTypes.string.isRequired,
  headerIcon: PropTypes.string.isRequired,
  headerTitle: PropTypes.string.isRequired,
  headerDescription: PropTypes.string,
};

GuidesHeader.defaultProps = {
  headerDescription: null,
};

export default GuidesHeader;
